import React from "react"
import PropTypes from "prop-types"
import { withRadium, DetectCompact } from "higher-order-components"
import { BackButton } from 'AtomicComponents'

const MyMazdaHeader = (props) => {
  /**
   * @param {Object|BackHyperlink} backButton - props for back button
   * @param {String} logo - logo location
   */
  const { backButton, logo, compact = false } = props

  return (
    <div
      style={{
        minHeight: "2em",
        position: "relative",
        padding: "1.2em 0",
        backgroundColor: "#FFF"
      }}>
      <BackButton
        top="50%"
        style={{ position: "absolute", transform: "translateY(-50%)", zIndex: "2" }}
        href={backButton.href}
        backText={backButton.name} />
      {!compact && (
        <div style={{ textAlign: "center" }}>
          <img style={{ maxWidth: "20em" }} src={logo} />
        </div>
      )}
    </div>
  )
}

MyMazdaHeader.propTypes = {
  backButton: PropTypes.shape({
    text: PropTypes.string,
    href: PropTypes.string,
    logo: PropTypes.string
  }),
  logo: PropTypes.string
}

export default withRadium(DetectCompact())(MyMazdaHeader)



// WEBPACK FOOTER //
// ./src/containers/mymazda-specifications-block/mymazda-header.jsx